import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { useHistory, Link } from "react-router-dom";
// import { useNavigate, Link } from "react-router-dom";

const Register = () => {
  // const navigate = useNavigate()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar();


  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */

 const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });
const [loading, setLoading] = useState(false)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  const register = async () => {
  if(!validateInput(formData)) return;
  setLoading(true) 
    try {
      // to dealy the response check loader
      // await new Promise((resolve)=> setTimeout(resolve, 2000))      
        const response = await axios.post(`${config.endpoint}/auth/register`,{  
          username: formData.username,
          password: formData.password,
        })
        if (response.status === 201) {
          enqueueSnackbar("Registered successfully", { variant: "success" });

          {history.push("/login", {from: "Register"})}

          // navigate("/login", { state: { from: "Register" } });
         
        }
      } catch (e) {
         if (e.response && e.response.status === 400) {
          return enqueueSnackbar(e.response.data.message, { variant: "error" });
        } else {
          enqueueSnackbar(
            "Something went wrong. check that the backend is running, reachable and return valid JSON.",
            { variant: "error" }
          );
        }
      
    } finally{
      setLoading(false)
    }

  
  };

 




  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    const { username, password, confirmPassword } = data;

    if (!username || !password || !confirmPassword) {
      enqueueSnackbar("All fields are required", { variant: "warning" });
      return false;
    }
    if (username.length < 6) {
      enqueueSnackbar("Username must be at least 6 characters", { variant: "warning" });
      return false;
    }
    if (password.length < 6) {
      enqueueSnackbar("Password must be at least 6 characters", { variant: "warning" });
      return false;
    }

    if (password !== confirmPassword) {
      enqueueSnackbar("Passwords do not match", { variant: "warning" });
      return false;
    }

    return true;

  };

  


  return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        minHeight="100vh"
      >
        <Header hasHiddenAuthButtons />
        <Box className="content">
          <Stack spacing={2} className="form">
            <h2 role="heading" className="title">Register</h2>
            <TextField
              id="username"
              label="Username"
              variant="outlined"
              title="Username"
              name="username"
              placeholder="Enter Username"
              onChange={handleInputChange}
              fullWidth
              required
            />
            <TextField
              id="password"
              variant="outlined"
              label="Password"
              name="password"
              type="password"
              helperText="Password must be atleast 6 characters length"
              fullWidth
              placeholder="Enter a password with minimum 6 characters"
              onChange={handleInputChange}
            />
            <TextField
              id="confirmPassword"
              variant="outlined"
              label="Confirm Password"
              name="confirmPassword"
              type="password"
              fullWidth
              onChange={handleInputChange}
            />{}
             <Button className="button" variant="contained" onClick={register} disabled={loading}>
              {loading ? <CircularProgress size={24} color="inherit" /> :  "Register Now"}
             
             </Button>
            <p className="secondary-action">
              Already have an account?{" "}
              <Link to="/login" className="link" >Login here</Link>
                
            </p>
          </Stack>
        </Box>
        <Footer />
      </Box>
    );



};








export default Register;
